/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import { Box, Flex } from '@rebass/grid';

import { Icon, Heading3, Text } from 'app/shared/ui';
import { USER_SUPPORT_PHONE_NUMBER } from 'app/constants';

import { HighlightedSpan } from '../../TradeIn.css';

import {
  ContainerSt,
  ButtonSt,
  PhoneLinkContainerSt,
  LinkSt,
} from './Contacts.css';

export const Contacts = () => {
  function handleClickChat() {
    const { HubSpotConversations } = window;
    if (HubSpotConversations && HubSpotConversations.widget) {
      HubSpotConversations.widget.open();
    }
  }

  return (
    <ContainerSt>
      <Heading3>
        Du benötigst <HighlightedSpan>Unterstützung?</HighlightedSpan>
      </Heading3>

      <Box mt={32} mb={[24, 32]}>
        <span>Kontaktiere uns täglich zwischen 9:00 und 18:00 Uhr.</span>
      </Box>

      <Flex
        flexDirection={['column', 'row']}
        justifyContent="center"
        alignItems="center"
      >
        <Box width={[1, 1 / 3]} mr={[0, 16]} mb={[16, 0, 0]}>
          <ButtonSt
            data-testid="tradein-contacts-button-chat"
            onClick={handleClickChat}
            width={1}
          >
            <Icon icon="chat" iconSize="xsmall" mr="8px" />
            <Text fontSize={14}>Chat starten</Text>
          </ButtonSt>
        </Box>

        <PhoneLinkContainerSt
          width={[1, 1 / 3]}
          ml={[0, 16, 0]}
          mr={[0, 0, 0, 32]}
        >
          <LinkSt useRouter={false} to={USER_SUPPORT_PHONE_NUMBER} width={1}>
            <Icon
              icon="call"
              iconSize="xsmall"
              mr="8px"
              css={{ verticalAlign: 'text-top' }}
            />
            <Text fontSize={14}>+49 (0) 30 2555 855 08</Text>
          </LinkSt>
        </PhoneLinkContainerSt>
      </Flex>
    </ContainerSt>
  );
};
